import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { PageIntro, ProseSections, useTranslatedList, type ProseSection } from './shared';

/** Review fix F11/F15: honest about the catalog's actual state -- every practice is a draft until
 * a real, named review is recorded, and the page says so rather than implying review. */
export function EditorialStandards() {
  const { t } = useTranslation();
  const sections = useTranslatedList<ProseSection>('public.editorial.sections');
  return (
    <div className="prose">
      <PageIntro title={t('public.editorial.title')} lead={t('public.editorial.lead')} />
      <ProseSections sections={sections} idPrefix="editorial" />
      <p className="landing-more">
        <Link to="/support" className="text-link">{t('public.editorial.reportLink')}</Link>
      </p>
    </div>
  );
}
